import React, { useState } from 'react';
import {
    button,
    Grid,
    Tooltip,
} from '@mui/material';
import { useHistory } from "react-router-dom";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Avatar from '@mui/material/Avatar';
import { AlternateEmail } from '@mui/icons-material';

const FormMangerLogin = () => {
    const history = useHistory();
    const [openProgressBar, setOpenProgressBar] = useState(false);
    const handleCloseProgressBar = () => {
        setOpenProgressBar(false);
    };
    const isManagerLogin = localStorage.getItem('pilotId') && (localStorage.getItem('pilotId').trim() !== "undefined" && localStorage.getItem('pilotId').trim() !== "" && localStorage.getItem('pilotId').trim() !== null) ? true : false;
    const isNoEventPage = window.location.pathname === '/NoEvent';
    const handleManagerLogin = () => {
        setOpenProgressBar(true);
        localStorage.setItem('roles', "");
        localStorage.setItem('pilotId', "");
        localStorage.setItem('loginUserName', "");
        setTimeout(() => {
            window.location.replace("/EventManager");
            setOpenProgressBar(false);
        }, 3000);


    }
    // Check if the current page path is /NoEvent
    const handleMainMenu = () => {
        history.push({ pathname: '/EventManager' });
    }

    return (
        <div class="flex flex-col items-center justify-center p-15 space-y-20">
            {
                isManagerLogin ?
                    (
                        // <Tooltip title="Main Menu">
                        //     <button variant="contained" className="bg-[#343434] hover:bg-gray-600 text-white rounded-full px-6 py-2 flex items-center justify-center space-x-2" onClick={handleMainMenu}>
                        //     </button>
                        // </Tooltip>
                        <button variant="contained" className="bg-[#343434] hover:bg-gray-600 text-white rounded-full px-6 py-2 flex items-center justify-center space-x-2" onClick={handleMainMenu}>
                            <span>Main Menu</span>
                        </button>
                    )
                    :
                    (
                       !isNoEventPage?
                        <div className="margin-bottom-10">
                            <Tooltip title="Manager Login">
                                <Avatar sx={{ bgcolor: '#343434' }} variant="rounded">
                                    <button variant="contained" className="bg-[#343434] hover:bg-gray-600 text-white rounded-full px-6 py-4 flex items-center justify-center space-x-2" onClick={handleManagerLogin}>
                                        <i className="fas fa-lock"></i>
                                    </button>
                                </Avatar>
                            </Tooltip>
                        </div>
                        :
                        <>
                         <div>
                            <button variant="contained" className="bg-[#343434] hover:bg-gray-600 text-white rounded-full px-6 py-2 flex items-center justify-center space-x-2" onClick={handleManagerLogin}>
                                <i className="fas fa-lock"></i>
                                <span>Manager Login</span>
                            </button>
                        </div>
                        </>
                    )
            }
            <Backdrop
                open={openProgressBar}
                onClick={handleCloseProgressBar}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div >
    );
};

export default FormMangerLogin;